import React from 'react';
import EmailIcon from '@hero/ui-kit/icons/branding/EmailIcon';
import * as styles from './journey.module.css';

type Props = {
    id: string;
    title: string;
    kind: 'email' | 'sms' | 'action' | 'check' | 'split';
    children: React.ReactNode;
    action?: React.ReactNode;
};
const StepCardFrame: React.FC<Props> = ({ id, title, kind, children, action }) => (
    <div className={styles.card} data-kind={kind}>
        <div className={styles.cardHeader}>
            <span className={styles.icon} aria-hidden="true">
                {kind === 'email' ? (
                    <EmailIcon size="utility" />
                ) : kind === 'sms' ? (
                    'SMS'
                ) : kind === 'split' ? (
                    'A/B'
                ) : kind === 'check' ? (
                    '?'
                ) : (
                    '↗'
                )}
            </span>
            <strong className={styles.cardTitle}>{title}</strong>
        </div>
        {children}
        <div className={styles.cardFooter}>
            <span className={styles.stepId} title={id}>
                {id}
            </span>
            {action}
        </div>
    </div>
);
export default StepCardFrame;
